import React, { useState } from 'react'

import { FormModal } from '@forgeglobal/design-framework'

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  return { isOpen, open, close }
}

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
}

const Modal: React.FC<ModalProps> = ({ open, onClose, title, children }) => (
  <FormModal open={open} title={title} hideModal={onClose}>
    <div>{children}</div>
  </FormModal>
)

export default Modal
